import { TypePolicy } from '@apollo/client';

export const projectTeamPolicy = {
    ProjectTeam: {
        fields: {
            assignments: {
                merge(_existing, incoming) {
                    // Perform any necessary data merging or transformation here
                    return [...incoming];
                }
            },
        },
    } as TypePolicy,
}